import styled from 'styled-components';

const KeyReverse = styled.button`
  padding: ${({ theme }) => theme.spacing[0]};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  border-radius: ${({ theme }) => theme.radii.xl};
  /* on rend le bord transparent, car c'est la couche de fond qui dessinera la couleur du bord */
  border: 4px solid transparent;

  /* 
    – couche 1 (padding-box) : background normal à l’intérieur du bouton 
    – couche 2 (border-box)  : backgroundReverse visible sous le padding + sous le bord
  */
  background: 
    ${({ theme }) => theme.colors.background} padding-box,
    ${({ theme }) => theme.colors.backgroundReverse} border-box;

  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;
`;

export default KeyReverse;